
import React from 'react';

// Parse message for @mentions (case-insensitive)
export const parseMentions = (message: string): string[] => {
  const mentionRegex = /@(\w+)/g;
  const mentions: string[] = [];
  let match;
  
  while ((match = mentionRegex.exec(message)) !== null) {
    mentions.push(match[1].toLowerCase()); // Convert to lowercase for case-insensitive matching
  }
  
  return [...new Set(mentions)]; // Remove duplicates
};

// Highlight mentions in message text - FIXED for better user matching
export const highlightMentions = (message: string, currentUsername?: string): React.ReactElement => {
  const mentionRegex = /@(\w+)/g;
  const parts = message.split(mentionRegex);
  
  return React.createElement(
    React.Fragment,
    null,
    ...parts.map((part, index) => {
      if (index % 2 === 1) {
        // This is a username part - now always case-insensitive
        const isCurrentUser = currentUsername && 
          part.toLowerCase() === currentUsername.toLowerCase();
        return React.createElement(
          'span',
          {
            key: index,
            className: `font-bold px-1 rounded text-sm ${
              isCurrentUser 
                ? 'bg-sports-green text-black' 
                : 'bg-blue-500 text-white'
            }`
          },
          `@${part}`
        );
      }
      return part;
    })
  );
};

// Helper function to create group-wide mentions
export const createGroupMention = (groupName: string, usernames: string[]): string => {
  return `@team ${usernames.map(username => `@${username}`).join(' ')}`;
};

// Check if message contains group-wide mentions
export const hasGroupMention = (message: string): boolean => {
  return message.toLowerCase().includes('@team') || message.toLowerCase().includes('@everyone');
};
